export enum WebsocketNotificationActionEnum
{
    NewNotificationToPatient = 1,
}